<template>
    <v-list dense class="kp-context-menu">
        <v-list-item @click="$emit('edit-item', record)">
            <v-list-item-icon>
                <v-icon>ic ic-20 ic-pencil ic-col-grey</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ $t('edit_contact') }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="!hideEditContact" @click="$emit('edit-contact', record)">
            <v-list-item-icon>
                <v-icon>ic ic-20 ic-preview ic-col-grey</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ $t('show_link') }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="!hideDeleteLink" @click="$emit('delete-link', record)">
            <v-list-item-icon>
                <v-icon>ic ic-20 ic-trash ic-col-grey</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ $t('delete_link') }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
import { Address } from '@/models/Address';

export default {
    name: 'AddressContactContextMenu',

    props: {
        record: {
            type: Address,
            default: () => null,
        },
        hideDeleteLink: {
            type: Boolean,
            default: false,
        },
        hideEditContact: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
